<template>
  <div class="dsfa-sc-todo-work-list">
    <div
      v-for="(item, index) in dataList"
      :key="index"
      :read="item.read == 1"
      class="dsfa-sc-todo-work-row"
      @lick="toUrl(item)"
    >
      <div class="dsfa-sc-todo-work__l">
        <div class="dsfa-sc-todo-work-title">
          <template>
            <div v-show="item.top == 1" class="dsfa-sc-todo-work-top">置顶</div>
            <img
              v-for="icon in item.signs || []"
              :key="icon.text"
              :src="icon.icon"
              :title="icon.text"
              class="dsfa-sc-todo-work-icon"
            />
          </template>
          <p class="dsfa-sc-todo-work-title__text" :title="item.title">
            {{ item.title }}
          </p>
        </div>
        <div class="dsfa-sc-todo-work-desc" :title="item.beizhu">
          {{ item.beizhu }}
        </div>
        <div class="dsfa-sc-todo-work-user">{{ item.user }}</div>
        <div class="dsfa-sc-todo-work-date">{{ item.date }}</div>
      </div>
      <div class="dsfa-sc-todo-work__r">
        <div
          v-for="btn in item.btns"
          :key="btn.key"
          class="dsfa-sc-todo-work-btn"
          @click.stop="btnClick(item, btn)"
        >
          <DsfIcon
            class="dsfa-sc-todo-work-btn-icon"
            :name="btn.icon || 'cygn'"
          />
          <div class="dsfa-sc-todo-work-btn-text">{{ btn.text }}</div>
        </div>
      </div>
      <div class="dsfa-sc-todo-work__user">{{ item.user }}</div>
      <div class="dsfa-sc-todo-work__user">{{ item.date }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DsfSCTodoWorkList",
  props: {
    dataList: {
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      icons: [
        {
          icon: require("../../../assets/styles/img/work/ji.png"),
          text: "加急",
        },
        {
          icon: require("../../../assets/styles/img/work/suo.png"),
          text: "锁住",
        },
        {
          icon: require("../../../assets/styles/img/work/xing.png"),
          text: "星级",
        },
      ],
      btns: [
        {
          key: "hf",
          icon: "icon-hf",
          text: "回复",
          handler: () => {},
        },
        {
          key: "gz",
          icon: "xing",
          text: "关注",
          handler: () => {},
        },
        {
          key: "ht",
          icon: "icon-th",
          text: "回退",
          handler: () => {},
        },
        {
          key: "zd",
          icon: "icon-zd",
          text: "置顶",
          handler: () => {},
        },
      ],
    };
  },
  methods: {
    toUrl({ url, openType }) {
      if (!url) return;
      this.$open({
        url,
        state: openType,
      });
    },
    btnClick(_, { url, openType }) {
      if (!url) return;
      this.$open({
        url,
        state: openType,
      });
    },
  },
};
</script>

<style lang="scss">
@import '_statistics-cloud/assets/styles/pc/todoWork.scss';
</style>